"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const LockOutlined_1 = __importDefault(require("@material-ui/icons/LockOutlined"));
const Visibility_1 = __importDefault(require("@material-ui/icons/Visibility"));
const VisibilityOff_1 = __importDefault(require("@material-ui/icons/VisibilityOff"));
const react_1 = require("react");
const components_1 = require("components");
/*
  This component is deprecated, use InputSSN instead
*/
function SSNInput(props) {
    const [focus, setFocus] = (0, react_1.useState)(false);
    const [visible, setVisible] = (0, react_1.useState)(false);
    const [rawSSN, setRawSSN] = (0, react_1.useState)('');
    const [showTip, setShowTip] = (0, react_1.useState)({
        ssn: false,
    });
    const { input: { onChange }, hidenote = false, } = props;
    const format = (v) => {
        v = v.slice(0, 11).replace(/-/g, '');
        if (v.length <= 3) {
            return v;
        }
        if (v.length > 3 && v.length <= 5) {
            return `${v.slice(0, 3)}-${v.slice(3)}`;
        }
        if (v.length > 5) {
            return `${v.slice(0, 3)}-${v.slice(3, 5)}-${v.slice(5)}`;
        }
        return '';
    };
    const handleShowTip = (tip) => {
        setShowTip({ ...showTip, [tip]: true });
    };
    const mask = (v) => {
        const masked = v.slice(0, 6).replace(/[0-9]/g, 'X');
        const unmaskedValue = v.length > 6 && v.slice(6, 11);
        return unmaskedValue ? `${masked}${unmaskedValue}` : masked;
    };
    const handleChange = (e) => {
        const { value } = e.target;
        if (value.replace(/-/g, '').length < rawSSN.length) {
            const last = rawSSN.length - 1;
            setRawSSN(rawSSN.slice(0, last));
            return;
        }
        const numValue = value.replace(/\D/g, '');
        let newSSN = '';
        if (rawSSN.length > 5) {
            newSSN = visible ? numValue : rawSSN.slice(0, 5) + numValue;
        }
        else {
            newSSN = visible ? numValue : rawSSN + numValue;
        }
        if (newSSN.length > 9) {
            return;
        }
        setRawSSN(newSSN);
        onChange(format(newSSN));
    };
    const handleVisibility = () => {
        setVisible(!visible);
        onChange(format(rawSSN));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "ssn-input--wrapper", children: [(0, jsx_runtime_1.jsxs)("div", { className: "ssn-input d-flex-center", children: [(0, jsx_runtime_1.jsx)("div", { style: { display: 'none' }, children: (0, jsx_runtime_1.jsx)(props.inputType, { name: props.input.name, ...props }) }), props.label && ((0, jsx_runtime_1.jsxs)("label", { htmlFor: props.input.name, children: [`${props.label
                                ? props.label
                                : 'Social Security Number / Individual Taxpayer Identification Number'}`, (0, jsx_runtime_1.jsx)("span", { className: "required-indicator", "aria-hidden": "true", children: "\u00A0*" })] })), (0, jsx_runtime_1.jsx)("input", { type: "tel", onFocus: () => {
                            setFocus(true);
                            handleShowTip('ssn');
                        }, placeholder: "Social Security Number / ITIN", onChange: handleChange, required: true, value: visible ? format(rawSSN) : mask(format(rawSSN)), onClick: () => {
                            handleShowTip('ssn');
                        } }), props.meta.touched && props.meta.error && ((0, jsx_runtime_1.jsx)("span", { id: "securityNumberError", className: "error-message", children: props.meta.error })), (0, jsx_runtime_1.jsx)("div", { onClick: handleVisibility, className: "ssn-input__visibility-icon", role: "button", tabIndex: 0, onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                handleVisibility();
                            }
                        }, children: visible ? (0, jsx_runtime_1.jsx)(Visibility_1.default, {}) : (0, jsx_runtime_1.jsx)(VisibilityOff_1.default, {}) })] }), (0, jsx_runtime_1.jsx)(components_1.FormSpy, { name: props.input.name, focused: focus, children: (val) => {
                    if ((val || focus) && props.tooltips) {
                        return (0, jsx_runtime_1.jsx)(props.tooltips, {});
                    }
                    return null;
                } }), showTip.ssn && hidenote === false && ((0, jsx_runtime_1.jsxs)("div", { className: "field-note social-security", children: [(0, jsx_runtime_1.jsx)(LockOutlined_1.default, { className: "gray-icon" }), (0, jsx_runtime_1.jsx)("p", { children: "\u00A0We use your social security or ITIN number to validate your information and check your credit. Your information is transmitted securely." })] }))] }));
}
exports.default = SSNInput;
